import useMeasure from 'app/components/layout/useMeasure';
import React from 'react';
import { useCss } from 'app/utils/css';
import { useI18n } from 'app/components/localization';
import BrandMaterialsLink from 'app/components/materials/BrandMaterialsLink';
import NavLink from 'app/components/presentation/nav/NavLink';
import SubNav from 'app/components/presentation/nav/SubNav';
import TranslationToggle from 'app/components/publishedLesson/LessonTranslationToggleWrapper';
import { DEFAULT_MEDIUM_BREAKPOINT } from 'app/constants/Breakpoints';
import NavToolbar, { NavSpacer } from 'app/components/presentation/nav/NavToolbar';
import WithFontsForLanguage from 'app/components/layout/WithFontsForLanguage';
import { ENGLISH } from 'app/constants/enums/Language';

const PublishedLessonNavigation = () => {
  const { t } = useI18n();
  const css = useCss();
  const [size, measureRef] = useMeasure();
  const isNarrow = size.width < DEFAULT_MEDIUM_BREAKPOINT;

  return (
    <SubNav getRef={measureRef}>
      <NavToolbar>
        <BrandMaterialsLink>
          {({ materialsUrl, dailyNewsUrl }) => (
            <>
              {materialsUrl && (
                <>
                  <NavLink to={materialsUrl} logo>
                    <span
                      className={css(
                        'logo',
                        isNarrow
                          ? {
                            fontSize: '18px',
                          }
                          : {
                            fontSize: '21px',
                            whiteSpace: 'nowrap',
                          },
                      )}
                    >
                      {t('lesson.navigation.all')}
                    </span>
                  </NavLink>
                  <NavLink to={materialsUrl}>{t('lesson.navigation.top')}</NavLink>
                </>
              )}

              {dailyNewsUrl && (
                <NavLink to={dailyNewsUrl}>
                  <WithFontsForLanguage languageCode={ENGLISH.id}>
                    {/* Should not be translated, because it is a brand name */}
                    Daily News
                  </WithFontsForLanguage>
                </NavLink>
              )}
            </>
          )}
        </BrandMaterialsLink>
        <NavSpacer />

        <TranslationToggle />
      </NavToolbar>
    </SubNav>
  );
};

export default PublishedLessonNavigation;
